import {
  Button,
  Group,
  Modal,
  NumberInput,
  Select,
  TextInput,
} from '@mantine/core'
import { DatePickerInput } from '@mantine/dates'
import { createStyles } from '@mantine/emotion'
import { showNotification } from '@mantine/notifications'
import { useSociSessionMutations } from 'modules/economy/mutations.hooks'
import { ALL_SOCI_SESSIONS } from 'modules/economy/queries'
import { SociSessionType } from 'modules/economy/types.graphql'
import { useState } from 'react'
import { enumHandler } from 'util/parsing'
import { useNavigate } from 'react-router-dom'
import { format } from 'util/date-fns'

interface CreateSociSessionModalProps {
  open: boolean
  onCloseCallback: () => void
}

export const CreateSociSessionModal: React.FC<CreateSociSessionModalProps> = ({
  open,
  onCloseCallback,
}) => {
  const { classes } = useStyles()
  const [name, setName] = useState('')
  const [minimumRemainingBalance, setMinimumRemainingBalance] = useState(0)
  const [type, setType] = useState<SociSessionType>(SociSessionType.KRYSSELISTE)
  const [date, setDate] = useState<string>(format(new Date(), 'yyyy-MM-dd'))
  const navigate = useNavigate()

  const { createSociSession } = useSociSessionMutations()

  function handleSubmit() {
    type Input = {
      name: string | null
      minimumRemainingBalance: number
      type: SociSessionType
      creationDate: string
    }
    const input: Input = {
      name: name.trim(),
      minimumRemainingBalance: minimumRemainingBalance,
      type,
      creationDate: date,
    }

    if (type === SociSessionType.STILLETIME) {
      input.name = null
    }

    if (name.trim() === '') return

    createSociSession({
      variables: {
        input,
      },
      refetchQueries: [ALL_SOCI_SESSIONS],
      onCompleted({ createSociSession: { sociSession } }) {
        onCloseCallback()

        showNotification({
          title: 'Suksess',
          message: 'krysseliste opprettet',
        })
        navigate(`${sociSession.id}`)
      },
      onError({ message }) {
        showNotification({
          title: 'Noe gikk galt',
          message,
        })
      },
    })
  }

  function handleCancel() {
    onCloseCallback()
  }

  return (
    <Modal opened={open} onClose={onCloseCallback} title="Ny innkryssing">
      <div className={classes.form}>
        <TextInput
          label="Navn på liste"
          value={name}
          onChange={evt => setName(evt.currentTarget.value)}
        />
        <DatePickerInput
          label="Dato for innkryssing"
          value={date}
          onChange={val => val && setDate(val)}
        />
        <Select
          label="Listetype"
          clearable={false}
          value={type}
          data={[
            {
              label: SociSessionType.KRYSSELISTE,
              value: SociSessionType.KRYSSELISTE,
            },
          ]}
          onChange={enumHandler(SociSessionType, setType)}
        />
        <NumberInput
          label="Minstebeløp gjenværende saldo"
          value={minimumRemainingBalance}
          min={0}
          onChange={val =>
            typeof val === 'number' && setMinimumRemainingBalance(val)
          }
        />
        <Group justify="flex-end">
          <Button color="gray" onClick={handleCancel}>
            Avbryt
          </Button>
          <Button color="samfundet-red" type="submit" onClick={handleSubmit}>
            Opprett
          </Button>
        </Group>
      </div>
    </Modal>
  )
}

const useStyles = createStyles({
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--mantine-spacing-md)',
  },
})
